<div>
  <dgx-modal-header (dismiss)="close()">{{
    certificateHeader
  }}</dgx-modal-header>
  <form class="form-wrap">
    <div class="grid dg-modal__body">
      <div class="grid__col-12">
        <img class="grid__cell-img" src="{{ item.imageUrl }}" />
      </div>
      <div class="grid__col-6">
        <div class="guts-p-b-1-half">
          <p class="par par--small" *ngIf="item.title">
            <span class="block font-semibold">{{ certificateTitle }}</span>
            <span class="block par--light">{{ item.title }}</span>
          </p>
          <p class="par par--small" *ngIf="item.url">
            <span class="block font-semibold">{{
              i18n.dgUserOutcomeEditForm_IssuerUrl
            }}</span>
            <span class="block par--light break">{{ item.url }}</span>
          </p>
        </div>
      </div>
      <div class="grid__col-6">
        <div class="guts-p-b-1-half">
          <p class="par par--small" *ngIf="item.source">
            <span class="block font-semibold">{{
              i18n.Cred_Certificate_Issuer
            }}</span>
            <span class="block par--light">{{ item.source }}</span>
          </p>
          <p class="par par--small">
            <span class="block font-semibold">{{
              i18n.Cred_Certificate_DateIssued
            }}</span>
            <span class="block par--light"
              >{{ item.startDate }}
              <span *ngIf="item.startDate && item.endDate"> - </span>
              <span *ngIf="item.endDate">{{ item.endDate }}</span></span
            >
          </p>
        </div>
      </div>
    </div>
  </form>
</div>
